<template>
	<div class="childDiv2" id="page9" ref="mainEl" page="2">
		<div class="childWrapper">
			<img alt="" src="images/1x_images/section2/page2/text-radiantskin.png" srcset="images/2x_images/section2/page2/text-radiantskin.png 2x" class="relative top-[210px] left-[90px]" />
			<div class="relative top-[260px] w-full pointer-events-auto">
				<div class="w-full relative top-[-25px]">
					<Carousel :images="serumImages" :top="30" :spaceBetween="-20" ref="carouselEl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import Carousel from "../../components/Carousel.vue";

export default {
	name: "page-1",
	components: { Carousel },
	data() {
		return {
			serumImages: ["section2/page2/serum-panel-1.png"],
		};
	},
	methods: {
		start() {},
		stop() {
			this.reset();
		},
		reset() {
			this.$refs.carouselEl.reset();
		},
	},
	mounted() {},
};
</script>

<style scoped></style>
